/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { SearchPublishedContent } from '@blaze-cms/nextjs-tools';
import { FaSearch } from 'react-icons/fa';

import { Link } from '@blaze-cms/nextjs-components';
import HeaderSearchLink from './HeaderSearchLink';

const HeaderSearch = ({
  handleSearchTerm,
  setIsSearchBarOpen,
  isSearchBarOpen,
  currentSearchTerm,
  closeSearchBar
}) => {
  const router = useRouter();
  const inputRef = useRef(null);
  const handleRoute = ({ pathname, query }) => {
    router.push({
      pathname,
      query
    });
  };

  const parsedResultKeys = ['PublishedArticle', 'PublishedSuperport'].reduce(
    (acc, value) => `${acc}... on ${value} {
      __typename,
      id,
      name,
      url,
      image {
        url
      }
    }
    `,
    ''
  );

  return (
    <SearchPublishedContent
      entities={['published_superport', 'published_article']}
      onEnterPress={() =>
        handleRoute({
          pathname: '/search',
          query: {
            search_term: currentSearchTerm
          }
        })
      }
      resultKeys={parsedResultKeys}
      placeholder="Search Dockwalk..."
      onChange={handleSearchTerm}
      SearchIcon={() => (
        <i>
          <FaSearch />
        </i>
      )}
      getIsOpenSearchBar={state => setIsSearchBarOpen(state)}
      isSearchBarOpen={isSearchBarOpen}
      fields={['name']}
      inputRef={isSearchBarOpen ? inputRef : null}>
      {({ results }) => {
        const shouldDisplayResults = !!results.length && isSearchBarOpen;
        const divClass = classnames({
          'search__modal-content-show': shouldDisplayResults,
          'search__modal-content': !shouldDisplayResults
        });
        return (
          <div className={divClass}>
            {shouldDisplayResults && (
              <>
                {results.map(({ __typename: entity, name, url, image }) => (
                  <Link key={name} href={url} onClick={closeSearchBar}>
                    <div className="search__modal-result">
                      {image && image.url && (
                        <img src={image.url} alt="miniature" className="search__modal-miniature" />
                      )}
                      <p>{name}</p>
                    </div>
                  </Link>
                ))}
                <HeaderSearchLink currentSearchTerm={currentSearchTerm} handleRoute={handleRoute} />
              </>
            )}
            {!results.length && currentSearchTerm && (
              <HeaderSearchLink currentSearchTerm={currentSearchTerm} handleRoute={handleRoute} />
            )}
          </div>
        );
      }}
    </SearchPublishedContent>
  );
};

HeaderSearch.propTypes = {
  handleSearchTerm: PropTypes.func.isRequired,
  setIsSearchBarOpen: PropTypes.func.isRequired,
  isSearchBarOpen: PropTypes.bool.isRequired,
  currentSearchTerm: PropTypes.string.isRequired,
  closeSearchBar: PropTypes.func.isRequired
};

export default HeaderSearch;
